import { supabase } from '@/lib/supabase/config';

export async function checkOrgSubscription(organizationId: number) {
  const { data, error } = await supabase.rpc('get_org_subscription', {
    p_organization_id: organizationId,
  });

  if (error) {
    throw new Error(error.message || 'Failed to check subscription');
  }

  return data;
}
